import useUser from '@/lib/hooks/useUser';
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const HeaderName = () => {
  const history = useNavigate();

  const {isAdmin} = useUser();

  const goHome = useCallback(
    (e) => {
      e.preventDefault();
      history('/');
    },
    [history]
  );

  return (
    <a
      aria-current="page"
      className="cds--header__name active"
      href="#top"
      onClick={goHome}>
      <span className="cds--header__name--prefix">
        <img width="75" src={require("images/micast_logo_small.png")} alt="micast" />
      </span>
      {isAdmin ? 'admin' : 'web'}
    </a>
  );
};
export default HeaderName;
